module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.canvasDisableHighlight();
        _vm.boxSetFormat(_vm.format);
      }
    }
  }, [_c('div', {
    staticClass: "box-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.format)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('span', {
    staticClass: "box-text"
  }, [_vm._t("description")], 2)])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3bea0276!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/types/items/GeneralItem.vue
 ** module id = 805
 ** module chunks = 1
 **/